// Script anti-flash injecté dans le <head>, exécuté AVANT le premier paint.
// Pose data-theme selon le choix persisté ; en mode "auto" (ou absent) on laisse
// le CSS `@media (prefers-color-scheme)` décider → aucun flash de thème incorrect.

export const THEME_STORAGE_KEY = 'rmbr-theme';

export const themeInitScript = `(function(){try{var m=localStorage.getItem('${THEME_STORAGE_KEY}');if(m==='light'||m==='dark'){document.documentElement.setAttribute('data-theme',m);}else{document.documentElement.removeAttribute('data-theme');}}catch(e){}})();`;
